import { API } from '../Api';

// Đếm ngược "subathon": streamer đặt thời lượng ban đầu + tỉ lệ "cứ X Ca thêm 1 phút", mỗi
// donate (qua DonateHandler, kể cả ẩn danh; trừ tự donate/chiến dịch) cộng thêm giờ theo tỉ lệ,
// có trần tổng thời lượng. Khác "Mục tiêu donate" (donate-goal) ở chỗ đây là đồng hồ đếm ngược
// hết giờ thì kết thúc, không phải thanh tiến độ theo số Ca.

export interface SubathonAdd {
  name: string;
  seconds: number;
  at: string;
}

export interface Subathon {
  exists: boolean;
  id: string;
  title: string;
  status: 'Running' | 'Paused' | 'Ended';
  remainingSeconds: number;
  totalSeconds: number;
  addedSeconds: number;
  caPerMinute: number;
  baseSeconds: number;
  maxTotalSeconds: number;
  isPaused: boolean;
  startedAt: string;
  endedAt: string | null;
  serverNow: string;
  lastAdd: SubathonAdd | null;
  recentAdds: SubathonAdd[];
}

export interface StartSubathonBody {
  title: string;
  baseMinutes: number;
  caPerMinute: number;
  maxHours: number;
}

const BASE = '/v1/payment-service/subathon';

export const getMySubathon = () => API.get<Subathon>(`${BASE}/me`).then((r) => r.data);

export const startSubathon = (body: StartSubathonBody) =>
  API.post<Subathon>(`${BASE}/start`, body).then((r) => r.data);

export const pauseSubathon = () => API.post<Subathon>(`${BASE}/pause`).then((r) => r.data);

export const resumeSubathon = () => API.post<Subathon>(`${BASE}/resume`).then((r) => r.data);

export const endSubathon = () => API.post<Subathon>(`${BASE}/end`).then((r) => r.data);

// Công khai — overlay OBS + trang cá nhân gọi được mà không cần đăng nhập.
export const getPublicSubathon = (userId: string) =>
  API.get<Subathon>('/v1/payment-service/public/creator-subathon', {
    params: { userId },
  }).then((r) => r.data);
